// extracted by mini-css-extract-plugin
export var cardcontainer = "CmsMapOverlayCard-module--cardcontainer--78118";
export var cardsectionbreak = "CmsMapOverlayCard-module--cardsectionbreak--f5153";
export var closeicon = "CmsMapOverlayCard-module--closeicon--6f087";
export var location = "CmsMapOverlayCard-module--location--23463";
export var title = "CmsMapOverlayCard-module--title--b3350";